<div  id="wrapper">
    <app-loading-screen></app-loading-screen>  
    <app-menu></app-menu>
    <div class="basicrow mbott">
        <div class="container">
            <div class="row">
                <div class="col-xs-12  col-md-8 col-lg-4 col-lg-offset-4   m-top-i mob-pos ajusteMargin">
                    <app-register-subscriber  (updateAccountType)="this.accountType=$event" (updateAccountSubType)="this.accountSubType=$event" (updateView)="viewSession=$event" (updateText)="this.txtType=$event" (updateSub)="this.account=$event" [(viewSession)]="this.viewSession"></app-register-subscriber>
                    <app-security-code 
                    [(accountType)]="this.accountType" 
                    [(accountSubType)]="this.accountSubType"  
                    (updateView)="viewSession=$event" 
                    (updateEmail)="this.email=$event" 
                    (updateSsn)="this.ssn=$event" 
                    (updateSubscriber)="this.subscriber=$event" 
                    (updateSecurityCode)="this.securityCode=$event" 
                    [(txtType)]="this.txtType" [(viewSession)]="this.viewSession" 
                    [(account)]="this.account"></app-security-code>
                    <app-password-set 
                    (updateView)="viewSession=$event" 
                    [(txtType)]="this.txtType" 
                    [(email)]="this.email" 
                    [(ssn)]="this.ssn" 
                    [(securityCode)]="this.securityCode" 
                    [(viewSession)]="this.viewSession" 
                    [(account)]="this.account" 
                    [(subscriber)]="this.subscriber"></app-password-set>
                    <div class="basicrow m-top-i">
                        <div class="logline full"></div>
                    </div>
                    <div class="basicrow text-center m-top-i">
                        <a ng-click="this.goToLogin()" routerLink="/"  class="linkdefs">Volver al inicio de sesi&oacute;n&nbsp;&nbsp;<i class="fa fa-angle-right" aria-hidden="true"></i></a>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <app-footer></app-footer>
  </div>